import { useEffect, useState } from "react";
import {
  ORDER,
  DESTRO,
  ORDER_MDPS,
  ORDER_RDPS,
  DESTRO_MDPS,
  DESTRO_RDPS,
  DPS,
  TANKS,
  DESTRO_DPS,
  ORDER_DPS,
  WEEK_TO,
  CAREER_NAME_MAP,
  WEEKS_ARRAY,
} from "../utils/constants";
import CareerIcon from "./career-icon";
import CareerRow from "./career-row";
import { loadChars, loadCareerStats } from "../http/fetch-status";
import ProgressBar from "@ramonak/react-progress-bar";
import getWeekNumber from "../utils/get-week-number";

const Careers = ({}) => {
  const [careers, setCareers] = useState();
  const [selected, setSelected] = useState(["SLAYER", "CHOPPA"]);

  const [loading, setLoading] = useState(false);
  const [showOutliers, setShowOutliers] = useState(false);
  const [showHistogram, setShowHistogram] = useState(false);
  const [showAverages, setShowAverages] = useState("totals");

  const [combatType, setCombatType] = useState("RVR");
  const [solo, setSolo] = useState("include-solo");

  const [weekFrom, setWeekFrom] = useState(WEEK_TO);
  const [weekTo, setWeekTo] = useState(WEEK_TO);

  const [timezone, setTimezone] = useState("0-23");
  const [rank, setRank] = useState("all");

  const [metric, setMetric] = useState("kills:died");
  const [progressPercentage, setProgressPercentage] = useState(0);
  const step = 1;
  const interval = 500;
  const maxProgress = 100;

  const [who, setWho] = useState("careers");
  const [sortOn, setSortOn] = useState("kills");
  const [playerSearch, setPlayerSearch] = useState("");
  const [scale, setScale] = useState(3);

  //const method = 1;

  const urlParams = new URLSearchParams(window.location.search);
  const version = urlParams.get("version");
  const pwd = urlParams.get("pwd");
  const method = version === "1.1" ? 1 : 1;
  const secret = pwd === "8549";

  const allGuilds = false;
  //&& careers && careers.filter((c) => c.guild).map((c) => c.guild);
  const guilds = allGuilds
    ? allGuilds.filter((v, i, a) => a.indexOf(v) === i)
    : [];

  const guildTotal = (key, guild) => {
    return careers
      .filter((c) => c.guild && c.guild === guild)
      .reduce((a, v) => (a = a + v[key]), 0);
  };
  const ifPlayers = () => {
    if (who === "players" || who === "guilds") {
      return true;
    }
  };

  /*
  useEffect(() => {
    if (who == "players") {
      selectOrder();
      setTimeout(() => {
        selectDestro();
      }, 100);
    }
  }, [who]);
  */

  const guildData =
    who === "guilds" &&
    guilds &&
    guilds.map((g) => {
      const kills = guildTotal("kills", g);
      const died = guildTotal("died", g);
      const assists = guildTotal("assists", g);
      const damage = guildTotal("damage", g);
      const guildClass = careers.filter((c) => c.guild && c.guild === g)[0]
        .career;

      if (kills >= 500) {
        const kd = kills / died;
        const kad = (assists + kills) / died;

        return {
          guild: g,
          kills: kills,
          died: died,
          assists: assists,
          damage: damage,
          kd: kd,
          kad: kad,
          career: guildClass,
        };
      }
      return null;
    });

  const fetchChars = async () => {
    console.log("FETCH -----------------------------");

    setProgressPercentage(10);
    let response;
    if (method == 0) {
      response = await loadChars();
    } else if (method == 1) {
      response = await loadCareerStats({
        combatType,
        solo,
        weekFrom,
        weekTo,
        timezone,
      });
    }

    if (response) {
      console.log(response.data.filter((c) => c.kills + c.died == 0));
      const fixedCareers = response.data.map((a) => {
        if (a.career in CAREER_NAME_MAP) {
          let b = { ...a };
          b.career = CAREER_NAME_MAP[a.career];
          return b;
        } else return a;
      });
      console.log(fixedCareers);
      setCareers(fixedCareers);
      setLoading(false);
      setProgressPercentage(0);
    }
  };

  useEffect(() => {
    if (loading === true) {
      fetchChars();
    }
  }, [loading]);

  useEffect(() => {
    if (!loading) {
      return setProgressPercentage(0);
    }
    const updateProgress = () =>
      setProgressPercentage(progressPercentage + step);

    if (progressPercentage < maxProgress && progressPercentage >= 1) {
      setTimeout(updateProgress, interval);
    }
  }, [progressPercentage]);

  useEffect(() => {
    if (loading === false) {
      setLoading(true);
    }
  }, [combatType, solo, weekTo, weekFrom, timezone]);

  const toggleCareer = (e) => {
    const career = e.currentTarget.dataset.career;
    if (selected.includes(career)) {
      setSelected([...selected.filter((c) => c != career)]);
    } else {
      setSelected([...selected, career]);
    }
  };

  const showCareers = () => {
    if (who === "careers") {
      return true;
    }
    if (who === "realm") {
      return true;
    }
  };

  const handleMetricChange = (e) => {
    setMetric(e.target.value);
  };

  const handleTypeChange = (e) => {
    setCombatType(e.target.value);
  };

  const handleSoloChange = (e) => {
    setSolo(e.target.value);
  };

  const handleWeekFromChange = (e) => {
    setWeekFrom(e.target.value);
  };

  const handleWeekToChange = (e) => {
    setWeekTo(e.target.value);
  };

  const handleTimezoneChange = (e) => {
    setTimezone(e.target.value);
  };

  const handleShowAverageChange = (e) => {
    setShowAverages(e.target.value);
  };

  const selectDestro = () => {
    const copy = [...selected];
    DESTRO.forEach((career) => {
      if (!copy.includes(career)) {
        copy.push(career);
      }
    });
    setSelected(copy);
  };

  const selectOrder = () => {
    const copy = [...selected];
    ORDER.forEach((career) => {
      if (!copy.includes(career)) {
        copy.push(career);
      }
    });
    setSelected(copy);
  };

  const selectOrderMDPS = () => {
    const copy = [...selected];
    ORDER_MDPS.forEach((career) => {
      if (!copy.includes(career)) {
        copy.push(career);
      }
    });
    setSelected(copy);
  };

  const selectDestroMDPS = () => {
    const copy = [...selected];
    DESTRO_MDPS.forEach((career) => {
      if (!copy.includes(career)) {
        copy.push(career);
      }
    });
    setSelected(copy);
  };

  const selectOrderRDPS = () => {
    const copy = [...selected];
    ORDER_RDPS.forEach((career) => {
      if (!copy.includes(career)) {
        copy.push(career);
      }
    });
    setSelected(copy);
  };

  const selectDestroRDPS = () => {
    const copy = [...selected];
    DESTRO_RDPS.forEach((career) => {
      if (!copy.includes(career)) {
        copy.push(career);
      }
    });
    setSelected(copy);
  };

  const getMetric = (c) => {
    switch (sortOn) {
      case "kills":
        return c.kills;
      case "assists":
        return c.assists;
      case "guildassists":
        return c.guild_assists;
      case "kills+assists":
        return c.kills + c.assists;
      case "damage":
        return c.damage;
      case "kills:died":
        return c.kills / getDeaths(c, 1);
      case "died":
        return c.died;
      case "killsassists:died":
        return (c.kills + c.assists) / getDeaths(c, 1);
      case "guildassists:died":
        return c.guild_assists / getDeaths(c, 1);
      case "assists:died":
        return c.assists / getDeaths(c, 1);
      case "damage:ka":
        return c.damage / (c.kills + c.assists);
      case "rank":
        return c.rr;
      default:
        return c.kills;
    }
  };

  const metricName = () => {
    if (metric === "kills:died") {
      return "KD";
    }

    if (metric === "killsassists:died") {
      return "KAD";
    }

    if (metric === "damage") {
      return "DMG:D";
    }

    return metric;
  };

  const getDeaths = (player, min) => {
    const died = player.died;

    if (died == 0) {
      return min;
    }
    return died;
  };

  const rankFilter = (player) => {
    if (rank === "all") {
      return true;
    }

    if (rank === "sub40") {
      if (player.level < 40) {
        return true;
      }
    }

    if (rank == "50+") {
      if (player.rr >= 50) {
        return true;
      }
    }

    if (rank == "60+") {
      if (player.rr >= 60) {
        return true;
      }
    }

    if (rank == "70+") {
      if (player.rr >= 70) {
        return true;
      }
    }

    if (rank == "80+") {
      if (player.rr >= 80) {
        return true;
      }
    }

    if (rank == "40-60") {
      if (player.rr >= 40 && player.rr < 60) {
        return true;
      }
    }

    if (rank == "60-80") {
      if (player.rr >= 60 && player.rr <= 80) {
        return true;
      }
    }

    if (rank == "sub80") {
      if (player.rr < 80) {
        return true;
      }
    }

    return false;
  };

  //console.log(WEEKS_ARRAY);

  const handleRankChange = (e) => {
    setRank(e.target.value);
  };

  const guildSort = (a, b) => {
    switch (sortOn) {
      case "kills":
        return b.kills - a.kills;
      case "assists":
        return b.assists - a.assists;
      case "kills+assists":
        return b.assists + b.kills - (a.assists + a.kills);
      case "damage":
        return b.damage - a.damage;
      case "kills:died":
        return b.kd - a.kd;
      case "died":
        return b.died - a.died;
      case "killsassists:died":
        return b.kad - a.kad;
      default:
        return b.kills - a.kills;
    }
  };

  return (
    <>
      <div className="py-5 font-bold">
        [ALPHA / TESTING] Kill/Death Box Plots for all careers in RVR
      </div>
      {loading && (
        <div className="absolute w-full py-10 bg-opa h-full">
          <div className="w-80 text-center font-bold">
            <div className="w-full">Counting Skulls on the Skull Throne...</div>
            <div className="px-8 my-2">
              <ProgressBar
                completed={progressPercentage}
                bgColor="#f90"
                borderRadius="0px"
                labelColor="#000000"
              />
            </div>
          </div>
        </div>
      )}

      {careers && (
        <>
          <div className="flex space-x-5">
            <div
              className="hover:cursor-pointer underline text-xs "
              onClick={() => setSelected([])}
            >
              clear all
            </div>
            <div
              className="hover:cursor-pointer underline text-xs"
              onClick={selectOrder}
            >
              select order
            </div>
            <div
              className="hover:cursor-pointer underline text-xs"
              onClick={selectDestro}
            >
              select destro
            </div>
            <div
              className="hover:cursor-pointer underline text-xs"
              onClick={selectOrderMDPS}
            >
              order MDPS
            </div>
            <div
              className="hover:cursor-pointer underline text-xs"
              onClick={selectDestroMDPS}
            >
              destro MDPS
            </div>
            <div
              className="hover:cursor-pointer underline text-xs"
              onClick={selectOrderRDPS}
            >
              order RDPS
            </div>
            <div
              className="hover:cursor-pointer underline text-xs"
              onClick={selectDestroRDPS}
            >
              destro RDPS
            </div>
          </div>
          <div className="grid grid-cols-2 gap-10 md:block md:space-y-5 my-10">
            <div className="grid grid-cols-2 md:grid-cols-6 lg:grid-cols-12 gap-2">
              {[...ORDER].map((career) => {
                return (
                  <div
                    className="flex space-x-2 text-xxs text-sky-500"
                    data-career={`${career}`}
                    onClick={toggleCareer}
                  >
                    <input
                      type="checkbox"
                      value={selected.includes(career)}
                      checked={selected.includes(career)}
                    />
                    <label className="w-6">
                      <CareerIcon career={career} />
                    </label>
                  </div>
                );
              })}
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-12 gap-2">
              {[...DESTRO].map((career) => {
                return (
                  <div
                    className="flex space-x-2 text-xxs text-red-500"
                    data-career={`${career}`}
                    onClick={toggleCareer}
                  >
                    <input
                      type="checkbox"
                      value={selected.includes(career)}
                      checked={selected.includes(career)}
                    />
                    <label className="w-6">
                      <CareerIcon career={career} />
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="text-black mt-5 mb-1 grid md:grid-cols-4 lg:grid-cols-8 gap-2 md:gap-10">
            <div className="flex flex-col">
              <label className="text-xs text-gray-500">AREA</label>
              <select onChange={handleTypeChange} disabled={method === 0}>
                <option value="RVR">RvR</option>
                <option value="SCENARIO T4">Scenario</option>
              </select>
            </div>

            <div className="flex flex-col">
              <label className="text-xs text-gray-500">SOLO</label>
              <select onChange={handleSoloChange} disabled={method === 0}>
                <option value="include-solo">Include Solo Kills</option>
                <option value="exclude-solo">Exclude Solo Kills</option>
                <option value="only-solo">Solo Kills Only</option>
              </select>
            </div>
            <div className="flex flex-col">
              <label className="text-xs text-gray-500">FROM</label>
              <select
                onChange={handleWeekFromChange}
                disabled={method === 0}
                value={weekFrom}
              >
                {WEEKS_ARRAY.map((week) => {
                  return (
                    <option value={week.value} key={week.value}>
                      {week.label}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="flex flex-col">
              <label className="text-xs text-gray-500">TO</label>
              <select
                onChange={handleWeekToChange}
                disabled={method === 0}
                value={weekTo}
              >
                {WEEKS_ARRAY.map((week) => {
                  return (
                    <option value={week.value} key={week.value}>
                      {week.label}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="flex flex-col">
              <label className="text-xs text-gray-500">TIMEZONE (utc)</label>
              <select
                onChange={handleTimezoneChange}
                disabled={method === 0}
                value={timezone}
              >
                <option value="0-23">All</option>
                <option value="0-5">0h-5am</option>
                <option value="6-11">6am-11am</option>
                <option value="12-17">12pm-5pm</option>
                <option value="18-23">6pm-11pm</option>
              </select>
            </div>
            <div className="flex flex-col">
              <label className="text-xs text-gray-500">LEVEL/RR</label>
              <select
                onChange={handleRankChange}
                disabled={method === 0}
                value={rank}
              >
                <option value="all">All</option>
                <option value="sub40">L16-39</option>
                <option value="50+">RR50+</option>
                <option value="60+">RR60+</option>
                <option value="70+">RR70+</option>
                <option value="80+">RR80+</option>
                <option value="40-60">RR40-60</option>
                <option value="60-80">RR60-80</option>
                <option value="sub80">{`< RR80`}</option>
              </select>
            </div>
          </div>
          <div className="text-ror mb-10 grid md:grid-cols-4 lg:grid-cols-8 gap-2 md:gap-10">
            <div></div>
            <div></div>
            <div
              className="text-center"
              onClick={() => {
                setWeekFrom(weekFrom - 0.01);
                setWeekTo(weekTo - 0.01);
              }}
            >
              <a>{"<<"}</a>
            </div>

            <div
              className="text-center"
              onClick={() => {
                setWeekFrom(weekFrom + 0.01);
                setWeekTo(weekTo + 0.01);
              }}
            >
              {">>"}
            </div>
          </div>
          <div className="text-black mt-5 mb-10 grid md:grid-cols-4 lg:grid-cols-8 gap-2 md:gap-10">
            <div className="flex flex-col">
              <label className="text-xs text-gray-500">WHAT</label>
              <select
                onChange={(e) => setWho(e.target.value)}
                disabled={method === 0}
                value={who}
              >
                <option value="careers">Careers</option>
                {/*<option value="realm">Realm/Archetypes</option>*/}
                {secret && <option value="players">Players</option>}
                {secret && <option value="guilds">Guilds</option>}
              </select>
            </div>

            {who == "players" ? (
              <div className="col-span-2 flex flex-col">
                <label className="text-xs text-gray-500">&nbsp;</label>
                <input
                  type="text"
                  value={playerSearch}
                  placeholder={`search player / guild`}
                  onChange={(e) =>
                    setPlayerSearch(e.target.value.toLowerCase())
                  }
                ></input>
              </div>
            ) : (
              <div className="flex flex-col col-span-2">
                <label className="text-xs text-gray-500">METRIC</label>
                <select onChange={handleMetricChange} disabled={method === 0}>
                  <option value="kills:died">Kill Credit (KD)</option>
                  <option value="killsassists:died">
                    Kill Contribution (KAD)
                  </option>
                  <option value="damage">Damage % per Death</option>
                  {/*<option value="killsassists:died">Guild Assists (GAD)</option>*/}
                </select>
              </div>
            )}
            <div className="col-span-3 text-gray-400 text-xs pt-3">
              <div>KD: Kill to Death Ratio</div>
              <div>KAD: Kills + Assists to Death Ratio</div>
              <div>DMG%: Perecntage of Damage done to a victim </div>
              <div>GAD: Guild Assists to Death Ratio</div>
            </div>
          </div>

          {ifPlayers() && (
            <div className="h-xscreen mt-5">
              <div className="grid grid-cols-12 text-center text-xs p-2">
                <div></div>
                <div className="col-span-1 text-left"></div>

                <div
                  className={`cursor-pointer hover:text-gray-200 ${
                    sortOn == "rank" ? "text-white font-bold" : "text-gray-400"
                  }`}
                  onClick={() => setSortOn("rank")}
                >
                  RR
                </div>
                <div
                  className={`cursor-pointer hover:text-gray-200 ${
                    sortOn == "kills" ? "text-white font-bold" : "text-gray-400"
                  }`}
                  onClick={() => setSortOn("kills")}
                >
                  Kills
                </div>
                <div
                  className={`cursor-pointer hover:text-gray-200 ${
                    sortOn == "assists"
                      ? "text-white font-bold"
                      : "text-gray-400"
                  }`}
                  onClick={() => setSortOn("assists")}
                >
                  Assists
                </div>
                <div
                  className={`cursor-pointer hover:text-gray-200 ${
                    sortOn == "kills+assists"
                      ? "text-white font-bold"
                      : "text-gray-400"
                  }`}
                  onClick={() => setSortOn("kills+assists")}
                >
                  K+A
                </div>
                <div
                  className={`cursor-pointer hover:text-gray-200 ${
                    sortOn == "guildassists"
                      ? "text-white font-bold"
                      : "text-gray-400"
                  }`}
                  onClick={() => setSortOn("guildassists")}
                >
                  Guild A
                </div>
                <div
                  className={`cursor-pointer hover:text-gray-200 ${
                    sortOn == "died" ? "text-white font-bold" : "text-gray-400"
                  }`}
                  onClick={() => setSortOn("died")}
                >
                  Died
                </div>
                <div
                  className={`cursor-pointer hover:text-gray-200 ${
                    sortOn == "damage"
                      ? "text-white font-bold"
                      : "text-gray-400"
                  }`}
                  onClick={() => setSortOn("damage")}
                >
                  DMG%
                </div>
                <div
                  className={`cursor-pointer hover:text-gray-200 ${
                    sortOn == "kills:died"
                      ? "text-white font-bold"
                      : "text-gray-400"
                  }`}
                  onClick={() => setSortOn("kills:died")}
                >
                  KD
                </div>
                <div
                  className={`cursor-pointer hover:text-gray-200 ${
                    sortOn == "killsassists:died"
                      ? "text-white font-bold"
                      : "text-gray-400"
                  }`}
                  onClick={() => setSortOn("killsassists:died")}
                >
                  KAD
                </div>
                <div
                  className={`cursor-pointer hover:text-gray-200 ${
                    sortOn == "guildsassists:died"
                      ? "text-white font-bold"
                      : "text-gray-400"
                  }`}
                  onClick={() => setSortOn("guildassists:died")}
                >
                  GAD
                </div>
                <div
                  className={`cursor-pointer hover:text-gray-200 hidden ${
                    sortOn == "assists:died"
                      ? "text-white font-bold"
                      : "text-gray-400"
                  }`}
                  onClick={() => setSortOn("assists:died")}
                >
                  AD
                </div>
              </div>
              <div>
                {who === "guilds" &&
                  guildData.length > 0 &&
                  guildData
                    .filter((g) => g)
                    .sort((a, b) => guildSort(a, b))
                    .map((guild) => {
                      if (guild) {
                        return (
                          <div className="grid grid-cols-11 text-center text-xs md:text-sm my-2 p-2 bg-ror">
                            <div>
                              <div className="w-6">
                                {ORDER.includes(guild.career) ? (
                                  <CareerIcon career={"ORDER"} />
                                ) : (
                                  <CareerIcon career={"DESTRUCTION"} />
                                )}
                              </div>
                            </div>
                            <div className="col-span-3">{guild.guild}</div>

                            <div>{guild.kills}</div>
                            <div>{guild.assists}</div>
                            <div>{guild.kills + guild.assists}</div>
                            <div>{guild.died}</div>
                            <div>{guild.damage}%</div>
                            <div>{guild.kd.toFixed(1)}</div>
                            <div>{guild.kad.toFixed(1)}</div>
                          </div>
                        );
                      }
                    })}
              </div>
              {who === "players" && (
                <div className="mb-20">
                  {careers
                    .filter((c) => selected.includes(c.career))
                    .filter((c) => rankFilter(c))
                    .filter(
                      (c) =>
                        c.name.toLowerCase().includes(playerSearch) ||
                        (c.guild &&
                          c.guild.toLowerCase().includes(playerSearch))
                    )
                    .filter((c) => c.died >= 0)
                    .sort((a, b) => getMetric(b) - getMetric(a))
                    .slice(0, 200)
                    .map((p) => {
                      return (
                        <div className="grid grid-cols-12 text-center text-xs md:text-sm my-2 p-2 bg-ror">
                          <div className="">
                            <div className="w-4 md:w-6">
                              <CareerIcon career={p.career} />
                            </div>
                          </div>
                          <div className="col-span-1 flex flex-col text-left">
                            <div>{p.name}</div>
                            <div className="text-xs text-gray-300">
                              {p.guild && `<${p.guild}>`}
                            </div>
                          </div>

                          <div>{p.rr}</div>
                          <div>{p.kills}</div>
                          <div>{p.assists}</div>
                          <div>{p.kills + p.assists}</div>
                          <div>{p.guild_assists}</div>
                          <div>{p.died}</div>
                          <div>{p.damage}%</div>
                          <div>{(p.kills / getDeaths(p, 1)).toFixed(1)}</div>
                          <div>
                            {((p.assists + p.kills) / getDeaths(p, 1)).toFixed(
                              1
                            )}
                          </div>
                          <div className="hidden">
                            {(p.assists / getDeaths(p, 1)).toFixed(1)}
                          </div>
                          <div>
                            {(p.guild_assists / getDeaths(p, 1)).toFixed(1)}
                          </div>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          )}
          {showCareers() && (
            <div className="min-h-screen">
              <div className="w-full bg py-2 px-2 grid grid-cols-12 gap-2 text-white text-xs">
                <div className="md:col-span-3"></div>
                <div className="text-center hidden md:block col-span-2">
                  <select
                    onChange={handleShowAverageChange}
                    className={`w-full`}
                  >
                    <option value="totals">Totals</option>
                    <option value="average">Averages</option>
                  </select>
                </div>
                <div className="text-xs text-white space-x-2 hidden md:block md-col-span-1 col-start-8">
                  <input
                    type="checkbox"
                    value={showHistogram}
                    checked={showHistogram}
                    onClick={() => setShowHistogram(!showHistogram)}
                  />
                  <label>Show histogram</label>
                </div>
                <div className="text-xs text-white space-x-2 col-span-4 col-start-1 md:col-start-9">
                  <input
                    type="checkbox"
                    value={showOutliers}
                    checked={showOutliers}
                    onClick={() => setShowOutliers(!showOutliers)}
                  />
                  <label>Show outliers</label>
                </div>
              </div>
              <div className="w-full bg py-2 px-2 grid grid-cols-12 gap-2 text-white text-xxs">
                <div className="md:col-span-1"></div>
                <div className="text-center hidden md:block">KIlls</div>
                <div className="text-center hidden md:block ">Assists</div>
                <div className="text-center hidden md:block ">DMG%</div>
                <div className="text-center hidden md:block ">Died</div>
                <div className="text-center">{metricName()} (mean)</div>
                <div className="text-center">{metricName()} (median)</div>
                <div className="col-span-1"></div>
              </div>
              <div className="mb-2">
                {who === "realm" && (
                  <>
                    <CareerRow
                      career={"ROR"}
                      careers={careers.filter((c) => rankFilter(c))}
                      outliers={false}
                      metric={metric}
                      method={method}
                      solo={solo}
                      showHistogram={false}
                      showOutliers={false}
                      limitKills={0}
                      limitDied={0}
                      scale={scale}
                      showAverages={showAverages}
                    />
                    <CareerRow
                      career={"ROR_DPS"}
                      careers={careers
                        .filter((c) => DPS.includes(c.career))
                        .filter((c) => rankFilter(c))}
                      outliers={showOutliers}
                      metric={metric}
                      method={method}
                      solo={solo}
                      showHistogram={false}
                      limitKills={0}
                      limitDied={0}
                      scale={scale}
                      showAverages={showAverages}
                    />
                    {/*}
                    <CareerRow
                      career={"ROR_TANKS"}
                      careers={careers
                        .filter((c) => TANKS.includes(c.career))
                        .filter((c) => rankFilter(c))}
                      outliers={showOutliers}
                      metric={metric}
                      method={method}
                      solo={solo}
                      showHistogram={false}
                      limitKills={0}
                      limitDied={0}
                      scale={scale}
                      />*/}
                    <CareerRow
                      career={"ORDER"}
                      careers={careers
                        .filter((c) => ORDER.includes(c.career))
                        .filter((c) => rankFilter(c))}
                      outliers={false}
                      metric={metric}
                      method={method}
                      solo={solo}
                      showHistogram={false}
                      limitKills={0}
                      limitDied={0}
                      scale={scale}
                      showAverages={showAverages}
                    />
                    <CareerRow
                      career={"ORDER_DPS"}
                      careers={careers
                        .filter((c) => [...ORDER_DPS].includes(c.career))
                        .filter((c) => rankFilter(c))}
                      outliers={showOutliers}
                      metric={metric}
                      method={method}
                      solo={solo}
                      showHistogram={false}
                      scale={scale}
                      showAverages={showAverages}
                    />
                    <CareerRow
                      career={"DESTRUCTION"}
                      careers={careers
                        .filter((c) => DESTRO.includes(c.career))
                        .filter((c) => rankFilter(c))}
                      outliers={false}
                      metric={metric}
                      method={method}
                      solo={solo}
                      showHistogram={false}
                      limitKills={0}
                      limitDied={0}
                      scale={scale}
                      showAverages={showAverages}
                    />
                    <CareerRow
                      career={"DESTRUCTION_DPS"}
                      careers={careers
                        .filter((c) => [...DESTRO_DPS].includes(c.career))
                        .filter((c) => rankFilter(c))}
                      outliers={showOutliers}
                      metric={metric}
                      method={method}
                      solo={solo}
                      showHistogram={false}
                      scale={scale}
                      showAverages={showAverages}
                    />
                  </>
                )}
                {who === "careers" &&
                  selected
                    //.filter((c) => selected.includes(c.career))
                    .map((career) => {
                      return (
                        <CareerRow
                          career={career}
                          careers={careers
                            .filter((c) => c.career == career)
                            .filter((c) => rankFilter(c))}
                          outliers={showOutliers}
                          metric={metric}
                          method={method}
                          solo={solo}
                          showHistogram={showHistogram}
                          scale={scale}
                          showAverages={showAverages}
                        />
                      );
                    })}
              </div>
              <div className="w-full px-2 grid grid-cols-12 gap-2 text-white text-xxs">
                <div className="md:col-span-2"></div>
                <div className="text-center hidden md:block "></div>
                <div className="text-center hidden md:block "></div>
                <div className="text-center hidden md:block "></div>
                <div className="text-center md:col-span-2"></div>
                <div className="md:col-span-5 col-span-7">
                  {[0, 1, 2, 3].map((i) => {
                    return (
                      <div
                        className="inline-block border-0 border-l pl-0.5 h-2"
                        style={{ width: "60px" }}
                      >
                        {metric === "kills:died"
                          ? (scale * 2 * i).toFixed(1)
                          : metric === "killsassists:died"
                          ? (scale * 5 * i).toFixed(1)
                          : (scale * 50 * i).toFixed(1)}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Careers;
